@if(extension$ | async; as extension) {
<span>
  Dial {{ extension | formatExtensions }} or
  <a [routerLink]="views.ADMIN_PBX_SETTINGS_VOICEMAIL_MANAGER" class="link">click here</a> to access
  your Voicemail manager
</span>
} @else {
<span>
  <a [routerLink]="views.ADMIN_PBX_SETTINGS_VOICEMAIL_MANAGER" class="link">Click here</a> to access
  your Voicemail manager
</span>
}
